import { createRoot } from 'react-dom/client';
import { SENTRY_DSN, SENTRY_ENV } from 'shared/config';
import { App } from './app/App';

import * as Sentry from '@sentry/browser';

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENV,
  });
}

const container = document.getElementById('root');
if (!container) throw new Error('Container not found');
const root = createRoot(container);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
